<app-receipt
  [display_columns]="displayedColumns"
  [staged_receipts]="staged_receipts"
  [sse_name]="'PaypalReceipt'"
  [upload_field_text]="'receipt.uploadPaypalReceipt' | translate"
  [validation_schema]="validation_s"
  [upload_handler]="client_proc"
  [lookupPermanent]="lookup_today"
  [wasm_split_pattern]="_wasm_split_pattern"
  [callme]="lookup_all"
  [available_filters]="available_f"
  [get_paginated_data]="get_paginated_data"
>
</app-receipt>
